var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.$route.meta.logoHeader)?_c('LogoHeader'):_vm._e(),_vm._v(" "),(!_vm.$route.meta.hideAppNavigation)?_c('AppNavigation'):_vm._e(),_vm._v(" "),_c('RouterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }